import { render, staticRenderFns } from "./RiskMatrix.vue?vue&type=template&id=be20d76c&scoped=true"
import script from "./RiskMatrix.vue?vue&type=script&lang=js"
export * from "./RiskMatrix.vue?vue&type=script&lang=js"
import style0 from "./RiskMatrix.vue?vue&type=style&index=0&id=be20d76c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be20d76c",
  null
  
)

export default component.exports